import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const SubmittedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M7.6191,7.1934c.1343,0,.2681-.0537.3667-.1602l3.5142-3.7886v14.7056c0,.2764.2236.5.5.5s.5-.2236.5-.5V3.1782l3.5146,3.7886c.1895.2036.5049.2139.7061.0269.2031-.188.2148-.5044.0264-.7065L12.0308,1.2017l-4.7783,5.1519c-.1875.2021-.1758.5186.0269.7065.0962.0894.2183.1333.3398.1333Z"
        className="primary"
      />
    </g>
    <path
      fill="currentColor"
      d="M23.5,15.2471c-.2764,0-.5.2236-.5.5v6.0508H1v-6.1094c0-.2764-.2236-.5-.5-.5s-.5.2236-.5.5v7.1094h24v-7.0508c0-.2764-.2236-.5-.5-.5Z"
      className="accent"
    />
  </svg>
);
export default withCustomIcon(SubmittedIcon);
